import Entity from "./Entity";

export default class FloorSpiderObstacle extends Entity {

    get collider() {
        return this._collider;
    }

    constructor(anchor, texture) {
        super(anchor, texture);

        this._activated = false;

        this._web = new PIXI.Sprite(P3.assets.texture("spider_web"));
        this._web.anchor = anchor.clone();
        this._web.y = -30;
        this.addChildAt(this._web, 0);

        this._collider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._collider.tint = 0xff0000;
        this._collider.width = 60;
        this._collider.height = 80
        this._collider.y = 90;
        this._collider.anchor = anchor.clone();
        this._collider.renderable = false;
        this.addChild(this._collider);

        this.headCollision = false;

    }

    setCollider(x, y, width, height) {
        this._collider.x = x;
        this._collider.y = y;
        this._collider.width = width;
        this._collider.height = height;
    }

    hit() {
        if (!this._activated) {
            this._activated = true;
           // this._view.visible = false;
            this._web.visible = false;
        }
    }

}